//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import { ref, computed, onMounted } from '@vue/composition-api'
import { useRouter, defaultDownloadAppByOS } from '@core/utils'
import 'video.js/dist/video-js.css'
import { mdiPlus, mdiRefresh, mdiLock, mdiDotsVertical, mdiStar } from '@mdi/js'
import { avatarText } from '@core/utils/filter'
import { getVideoPlaybackType, logUserActivity } from '@api'
import themeConfig from '@themeConfig'
import { useUtils } from '@core/libs/i18n'
import { loadLanguageAsync } from '@/plugins/i18n'
import useShare from '@core/utils/useShare'

export default {
  setup() {
    const { shareURL } = useShare()
    const hostLocation = window.location.href
    const videoData = ref({
      end_playback_time: null,
      facility_logo: null,
      facility_name: null,
      field_name: null,
      highlight_name: null,
      highlight_owner: null,
      highlight_owner_avatar: null,
      share_user: null,
      share_user_avatar: null,
      start_playback_time: null,
      thumbnails: null,
      video_date: null,
      video_id: null,
      video_link: null,
      video_long: null,
      video_thumbnail: null,
      video_time: null,
      video_type: null,
      cam_coords: [],
    })
    const refUsername = ref(null)
    const refVideo = ref(null)
    const players = ref({})
    const logo = ref(require('@/assets/images/icons/logo.png'))
    const source = ref('https://static.smartisanos.cn/common/video/smartisan-tnt-jianguo.mp4')
    const initdone = ref(false)
    const cover = ref(
      'https://static.smartisanos.cn/pr/assets/images/smartisan-tnt-jianguo.190162f215c4f5f2aaabf38e5782b3af.jpg',
    )

    const playerOptions = ref({
      controls: false,
      responsive: true,
      breakpoints: true,
      fill: true,
      autoplay: true,
      muted: true,
      loop: true,
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [],
      poster: 'https://fanaty-api-stage.s3.amazonaws.com/no-thumb.jpg',
      notSupportedMessage: 'Este video no está disponible temporalmente, intente nuevamente más tarde.',
      usingPlugin: true,
      fluid: true,
      aspectRatio: '16:9',
    })
    const USER_ACT_VIEW_HIGHLIGHT_WEB = 'Open Highlight Web'
    const { t } = useUtils()
    const { route, router } = useRouter()
    const refVideoPlayer = ref(null)
    const player = computed(() => refVideoPlayer.value.player)
    let vmplayer = null
    let vmIntervalT = null
    const onPlayerTimeupdate = auxPlayer => {
      if (
        // eslint-disable-next-line operator-linebreak
        videoData.value &&
        // eslint-disable-next-line operator-linebreak
        (auxPlayer.currentTime() >= videoData.value.end_playback_time ||
          auxPlayer.currentTime() < videoData.value.start_playback_time)
      ) {
        initdone.value = false
        auxPlayer.currentTime(videoData.value.start_playback_time)
      }
    }
    const onPlayerCanplaythrough = auxPlayer => {
      if (!initdone.value && videoData.value && videoData.value.video_type === 'H') {
        auxPlayer.currentTime(videoData.value.start_playback_time)
        initdone.value = true
      }
    }

    const onPlayerCanplay = auxPlayer => {
      auxPlayer.currentTime(videoData.value.start_playback_time)
    }

    const playerReadied = auxPlayer => {
      if (!initdone.value && videoData.value && videoData.value.video_type === 'H') {
        auxPlayer.currentTime(videoData.value.start_playback_time)
        initdone.value = true
      }
    }

    const onPlayerLoadeddata = auxPlayer => {
      auxPlayer.currentTime(videoData.value.start_playback_time)
    }

    const onPlayerLoadedmetadata = auxPlayer => {
      if (!initdone.value && videoData.value && videoData.value.video_type === 'H') {
        auxPlayer.currentTime(videoData.value.start_playback_time)
        initdone.value = true
      }
    }

    function arrayToObject(array) {
      const obj = {}
      array.forEach(item => {
        const key = Object.keys(item)[0]
        obj[key] = item[key]
      })

      return obj
    }

    function playHighlightLoop(startTime, endTime, currentTime, elplayer, loop = false, objCameraPositions = [], avgY = 0) {
      const frameRate = 20
      if (currentTime >= endTime && loop) {
        // Calculate average of all 'y' values in camCoords

        clearInterval(vmIntervalT)
        elplayer.currentTime(startTime)
        vmIntervalT = setInterval(() => {
          const currentFrame = Math.floor(elplayer.currentTime() * frameRate)

          if (objCameraPositions[`${currentFrame}`]) {
            elplayer.vr().camera.position.set(objCameraPositions[`${currentFrame}`].x, avgY, objCameraPositions[`${currentFrame}`].z)
          }
        }, 60 / frameRate)
      }
    }

    function setManualViewerVideo(videoRNData, enableMotion = true) {
      try {
        const objCameraPositions = arrayToObject(videoRNData.value.cam_coords)
        const yValues = videoRNData.value.cam_coords.map(item => Object.values(item)[0].y)
        const avgY = yValues.reduce((sum, val) => sum + val, 0) / (yValues.length || 1)

        vmplayer = window.videojs('player', {
          disablePictureInPicture: true,
          aspectRatio: '16:9',
          controlBar: {
            playToggle: false,
            captionsButton: false,
            chaptersButton: false,
            subtitlesButton: false,
            remainingTimeDisplay: false,
            progressControl: {
              seekBar: true,
            },
            fullscreenToggle: false,
            playbackRateMenuButton: false,
          },
          userActions: {
            doubleClick: false,
          },
        })
        vmplayer.src({ type: 'video/mp4', src: videoRNData.value.video_stitched_link })
        // eslint-disable-next-line no-use-before-define
        vmplayer.nuevo({
          shareMenu: false,
          zoomMenu: false,
          contextMenu: false,
          relatedMenu: false,
          rateMenu: false,
          settingsButton: false,
        })

        if (!vmplayer.mediainfo) {
          vmplayer.mediainfo = {}
        }

        if (!vmplayer.mediainfo.projection) {
          vmplayer.mediainfo.projection = '360'
        }

        vmplayer.vr({ projection: '360', motionControls: true })

        vmplayer.load()
        window.addEventListener('deviceorientation', event => {
          // Rotación alrededor del eje Z (0 a 360 grados)
          const { beta } = event // Inclinación frontal/trasera del dispositivo (-180 a 180 grados)
          if (beta > 80) {
            vmplayer.vr().camera.position.set(vmplayer.vr().camera.position.x, 0, vmplayer.vr().camera.position.z)
            vmplayer.vr().controls3d.update()
          }
        })
        vmplayer.on('loadedmetadata', () => {
          setTimeout(() => {
            player.vr().camera.position.set(0, 0, 0)
            const maxPolarAngle = 59 * (Math.PI / 180)
            const minPolarAngle = 90 * (Math.PI / 180)

            vmplayer.vr().camera.position.set(0, 0, 0)

            vmplayer.vr().controls3d.orbit.maxPolarAngle = maxPolarAngle
            vmplayer.vr().controls3d.orbit.minPolarAngle = minPolarAngle
            vmplayer.vr().controls3d.orbit.maxAzimuthAngle = Math.PI / 2.6
            vmplayer.vr().controls3d.orbit.minAzimuthAngle = -Math.PI / 2.6
            vmplayer.vr().controls3d.update()
          }, 1000)

          if (vmplayer.vr() && vmplayer.vr().camera) {
            vmplayer.vr().camera.zoom = 0.8
            vmplayer.vr().camera.fov = 50
            vmplayer.vr().camera.updateProjectionMatrix()
            if (!enableMotion) {
              setTimeout(() => {
                vmplayer.vr().controls3d.orientation.disableDevice()
              }, 1000)
            }
          }
          vmplayer.currentTime(videoRNData.value.start_playback_time)

          vmIntervalT = setInterval(() => {
            const currentFrame = Math.floor(vmplayer.currentTime() * 20)
            if (objCameraPositions[`${currentFrame}`]) {
              vmplayer.vr().camera.position.set(objCameraPositions[`${currentFrame}`].x, avgY, objCameraPositions[`${currentFrame}`].z)
            }
          }, 60)
        })

        vmplayer.on('timeupdate', () => {
          const current = vmplayer.currentTime()
          playHighlightLoop(
            videoRNData.value.start_playback_time,
            videoRNData.value.end_playback_time,
            current,
            vmplayer,
            true,
            objCameraPositions,
            avgY,
          )
        })

        vmplayer.on('error', () => {
          console.log('error', vmplayer.error())
        })
        window.addEventListener('resize', () => {
          vmplayer.vr().camera.aspect = 1.77

          vmplayer.vr().camera.updateProjectionMatrix()
          vmplayer.vr().controls3d.handleResize()
        })

        // player.vr().controls3d.update()
      } catch (error) {
        console.log('🚀 ~ setManualViewerVideo ~ error:', error)
      }
    }

    onMounted(async () => {
      // loadLanguageAsync(navigator.language.includes('en') ? 'en' : 'es' || 'en')
      loadLanguageAsync('en')
      refVideo.value = route.value.params.playback
      refUsername.value = route.value.params.username

      const response = await getVideoPlaybackType(refVideo.value, 'H', refUsername.value)
      if (response.ok) {
        videoData.value = response.data
        if (videoData.value.cam_coords.length) {
          setManualViewerVideo(videoData, false)
          document.getElementById('player').style.pointerEvents = 'none'
        } else {
          playerOptions.value.sources.push({
            type: 'video/mp4',
            src: videoData.value.video_link,
          })

          logUserActivity({
            user_id: videoData.value.highlight_owner,
            video_id: null,
            highlight_id: videoData.value.highlight_id,
            action: USER_ACT_VIEW_HIGHLIGHT_WEB,
          })
        }
      } else {
        router.push({
          path: '/video-not-available',
        })
      }
    })

    const downloadApp = () => {
      // if (isAndroid()) window.open('https://play.google.com/store/apps/details?id=com.fanaty', '_blank')
      // if (isIOS()) window.open('https://apps.apple.com/us/app/fanaty/id1461051554', '_blank')
      // if (getOS() === 'Other') window.open('https://fanaty.com/download', '_blank')
      // downloadAppByOS(
      //   'https://play.google.com/store/apps/details?id=com.fanaty',
      //   'https://apps.apple.com/us/app/fanaty/id1461051554',
      //   'https://fanaty.com/download',
      // )
      defaultDownloadAppByOS(true)
    }

    return {
      videoData,
      refUsername,
      refVideo,
      players,
      logo,
      initdone,
      source,
      cover,
      USER_ACT_VIEW_HIGHLIGHT_WEB,
      hostLocation,
      onPlayerTimeupdate,
      onPlayerCanplaythrough,
      onPlayerCanplay,
      onPlayerLoadeddata,
      onPlayerLoadedmetadata,
      playerReadied,
      player,
      playerOptions,
      downloadApp,
      avatarText,
      shareURL,

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logoTitleBlack,

      // i18n
      t,

      icons: {
        mdiPlus,
        mdiRefresh,
        mdiLock,
        mdiDotsVertical,
        mdiStar,
      },
    }
  },
}
